import React from "react";
import {
  Box,
  Grid,
  Typography,
  TextField
} from "@mui/material";
import { Controller } from "react-hook-form";

const NewAddressDetails = ({ control, errors }) => {
  return (
    <Box>
      <Typography variant="subtitle1" fontWeight="bold" color="textSecondary" gutterBottom>
        Address Details
      </Typography>

      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} sm={6}>
          <Controller
            name="address"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Address"
                variant="outlined"
                fullWidth
                error={!!errors.address}
                helperText={errors.address?.message}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="landmark"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Landmark"
                variant="outlined"
                fullWidth
                error={!!errors.landmark}
                helperText={errors.landmark?.message}
              />
            )}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} sm={4}>
          <Controller
            name="locality"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Village/Town"
                variant="outlined"
                fullWidth
                error={!!errors.locality}
                helperText={errors.locality?.message}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Controller
            name="tehsil"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Tehsil"
                variant="outlined"
                fullWidth
                error={!!errors.tehsil}
                helperText={errors.tehsil?.message}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Controller
            name="district"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="District"
                variant="outlined"
                fullWidth
                error={!!errors.district}
                helperText={errors.district?.message}
              />
            )}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} sm={6}>
          <Controller
            name="state"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="State"
                variant="outlined"
                fullWidth
                error={!!errors.state}
                helperText={errors.state?.message}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="pincode"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Pincode"
                variant="outlined"
                fullWidth
                type="number"
                error={!!errors.pincode}
                helperText={errors.pincode?.message}
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default NewAddressDetails;
